import isWxClient from "./tools/isWxClient.js";

class wxFactory {
	constructor({ scope = "snsapi_userinfo", appid, envid, signature = window.location.href, wxserver } = {}) {
		this.scope = scope;
		this.appid = appid;
		this.envid = envid;
		this.signature = signature;
		this.wxserver = wxserver;
		this.result = "";
	}

	async login() {
		const mplogin = await window.mplogin({
			scope: this.scope, // 必填，登录方式：snsapi_userinfo、snsapi_base
			appid: this.appid, // 必填，公众号appid，将以此appid名义进行请求
			// redirect: window.location.href, // 选填，授权成功后路由的地址，目标地址应能处理授权参数，不填为当前页面
			envid: this.envid, // 选填，资源方微信云托管环境，如果传递此参数则会返回初始化的cloud操作对象
			signature: this.signature, // 选填，如果需要微信SDK的API方法，则填写要使用的地址，会返回signature签名对象，envid参数不填则无效。
			// region: ''                         // 选填，环境的地域，可选ap-guangzhou、ap-beijing，不填默认为ap-shanghai
			// traceUser:false                    // 选填，默认true，是否在将用户访问记录到用户管理中，非上海地域请设置成false
			// noback: true                       // 选填，默认noback:false，此时初次跳转授权后，模块将重新回退加载页面。
			// 由于CloudSDK在初次登录时需要多个页面跳转，最终带参返回页面在浏览器页面栈中多了一到两层
			// 你可以根据业务自行用history处理上述问题，不需要模块介入则填noback:true
		});

		if (mplogin.ret == 0) {
			this.result = mplogin;
			if (this.scope == "snsapi_userinfo") {
				const userInfo = await mplogin.cloud.callContainer({
					path: "/wx/getUserInfo",
					method: "POST",
					header: {
						"X-WX-SERVICE": this.wxserver, // xxx中填入服务名称（微信云托管 - 服务管理 - 服务列表 - 服务名称）
					},
					data: {
						cloudid: [mplogin.info],
					},
				});
				const userData = JSON.parse(userInfo.data.data);
				console.log("%c -----> 002 userData");
				console.log(userData);
				// this.wxConfig();
				return {
					mplogin,
					userInfo: JSON.parse(userData.data_list[0]["json"])["data"],
				};
			} else {
				return {
					mplogin,
				};
			}
		} else {
			console.log("%c -----> 001wx登录", "font-size:13px; background:pink; color:#bf2c9f;", "微信登录失败");
			throw false;
		}
	}

	wxConfig() {
		console.log("%c -----> 001 微信注册", "font-size:13px; background:pink; color:#bf2c9f;", "微信注册");
		// 发起签名注册，是一个异步操作，成功会触发
		wx.config({
			appId: this.appid, // 微信公众号appid
			timestamp: this.result.signature.timestamp + "", // 时间戳，从返回result.signature中获取
			nonceStr: this.result.signature.nonceStr, // 随机字符串，从返回result.signature中获取
			signature: this.result.signature.signature, // 签名，从返回result.signature中获取
			jsApiList: ["chooseWXPay"], // 注册的api列表
		});
	}

	wxConfigWxPay() {
		wx.config({
			appId: this.appid, // 微信公众号appid
			timestamp: this.result.signature.timestamp + "", // 时间戳，从返回result.signature中获取
			nonceStr: this.result.signature.nonceStr, // 随机字符串，从返回result.signature中获取
			signature: this.result.signature.signature, // 签名，从返回result.signature中获取
			jsApiList: ["chooseWXPay"], // 注册的api列表
		});
	}

	wxConfigScanQRCode() {
		wx.config({
			appId: this.appid, // 微信公众号appid
			timestamp: this.result.signature.timestamp + "", // 时间戳，从返回result.signature中获取
			nonceStr: this.result.signature.nonceStr, // 随机字符串，从返回result.signature中获取
			signature: this.result.signature.signature, // 签名，从返回result.signature中获取
			jsApiList: ["scanQRCode"], // 注册的api列表
		});
	}

	async post(url, data = {}) {
		const result = await this.result.cloud.callContainer({
			path: url, // 填入业务自定义路径和参数，根目录，就是 /
			method: "POST", // 按照自己的业务开发，选择对应的方法
			header: {
				"X-WX-SERVICE": this.wxserver, // xxx中填入服务名称（微信云托管 - 服务管理 - 服务列表 - 服务名称）
			},
			data: data,
		});

		if (result.data.code == "200") {
			return result.data.data || result.data;
		} else {
			throw result.data;
		}
	}
}

export default wxFactory;
